import { render, staticRenderFns } from "./AddFunctionaryAccount.vue?vue&type=template&id=713023a2&"
import script from "./AddFunctionaryAccount.vue?vue&type=script&lang=js&"
export * from "./AddFunctionaryAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports